import { fromDate, toCalendarDateTime } from '@internationalized/date';
import { enumServiceStatus } from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { ServiceFormState } from '~/modules/transportation/types';
import { store } from '~/shared/state';
import { $localization } from '~/shared/state/preferences.state';

const initialState = (): ServiceFormState => {
  const localTimezone = store.get($localization).timezone;
  const currentDateTime = toCalendarDateTime(
    fromDate(new Date(), localTimezone),
  );

  return {
    typeId: undefined,
    status: enumServiceStatus.Draft,
    rank: 'L',
    priority: 0,
    scheduledWindowStart: currentDateTime,
    scheduledWindowEnd: currentDateTime,
    internalNotes: '',
    externalNotes: '',
    driverNotes: '',
    assetIds: [],
    assetQuantities: [],
    facilityGroupId: null,
    facilityId: null,
    destinationFacilityId: null,
    accountId: null,
    routeId: null,
    accountAddressId: null,
    haulerId: null,
  };
};

export const $serviceForm = atom<ServiceFormState>(initialState());

export const $resetServiceForm = atom(null, (get, set) => {
  set($serviceForm, initialState());
});

export const $updateServiceForm = atom(
  null,
  (get, set, update: Partial<ServiceFormState>) => {
    const current = get($serviceForm);
    set($serviceForm, { ...current, ...update });
  },
);
